/**
 * @desc 导出费用映射
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.costItemMapping.exportCostItemMappingInfo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costItemMapping/exportCostItemMappingInfo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
